module.exports = __webpack_public_path__ + "static/grip-d13115dead352e4112a0ecd7796d56b2.jpg";